import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <>
  
      <Navbar />
      <Outlet />
      <Footer />
      
    </>
  );
};
export default Home;
